import React, { useMemo, useState } from 'react'
import { GenderFeMale, GenderMale, GenderOther } from '../../assets/Logos/Icons'
import styles from './genderpicker.module.scss'

function GenderPicker({ onChange, value,disabled }) {

    const [gender, setGender] = useState("Male")

    const gemderList = [
        {
            name: "Male",
            icon: <GenderMale isActive={gender === "Male"} />
        },
        {
            name: "Female",
            icon: <GenderFeMale isActive={gender === "Female"} />
        },
        {
            name: "Other",
            icon: <GenderOther isActive={gender === "Other"} />
        }
    ]


    const handleOnChange = value => {
        if(!disabled){
            setGender(value)
            if (onChange) { onChange(value) }
        }
    }



    useMemo(() => { value && setGender(value) }, [value])

    return (
        <div className={styles.container}>

            {
                gemderList.map((each, key) => {
                    return (
                        <div
                            key={key}
                            onClick={() => { handleOnChange(each.name) }}
                            className={`${styles.gender_item} ${gender === each.name && styles.gender_item_active}`}>
                            {each?.icon}
                        </div>
                    )
                })
            }


        </div>
    )
}

export default GenderPicker